<template>
  <div>
    <Breadcrumbs
      :breadcrumbs="[
      {title: this.$t(`menu.${serviceSlug}`), disabled: true},
      {title: this.$t('menu.iframe/media-library'), disabled: true}
    ]">
      <div slot="breadcrumbAfter" class="d-flex align-items-center">
        <Searchable class="mr-2" :querySearch.sync="querySearch" />
        <Filters
          :isActive="showFilters"
          :activeFilters="activeFilters"
          @toggle-filters="toggleFilters" />
      </div>
    </Breadcrumbs>

    <FadeTransition
      :duration="400"
      mode="out-in">
      <div class="btn btn__floating btn__round__large btn__round__large">
        <va-popover
          :message="$t('iframe.media_library.create')"
          placement="left"
        >
          <va-button
            @click.prevent="onClickCreateMedia">
            <i class="fa fa-plus"></i>
          </va-button>

        </va-popover>

      </div>
    </FadeTransition>

    <MediaTable
      ref="iframeMediaTable"
      :showFilters.sync="showFilters"
      :querySearch="querySearch"
      @filters-updated="onFiltersUpdated"
      @mediaClicked="onMediaClicked"
    />

    <CreateMedia
      v-if="showCreateMedia"
      @created="onCreated"
      @cancel="onMediaCreateCancel"
    />
  </div>
</template>

<script>
import Breadcrumbs from "@/components/common/Breadcrumbs";
import Filters from "@/components/common/Filters";
import Searchable from "@/components/common/Searchable";
import IndexTablesMixin from "@/mixins/IndexTablesMixin";
import {TABLE_IFRAME_MEDIA_LIBRARY} from "@/local-storage/LocalStorageKeys";
import MediaTable from "@/components/iframe/media-library/MediaTable";
import FadeTransition from "@/components/common/transitions/FadeTransition";
import CreateMedia from "@/components/iframe/media-library/CreateMedia";
export default {
  props: {
    serviceSlug: {
      type: String,
      required: true
    }
  },
  components: {CreateMedia,  FadeTransition, MediaTable, Searchable, Filters, Breadcrumbs},
  mixins: [
    IndexTablesMixin
  ],
  data () {
    return {
      querySearch: '',
      showFilters: false,
      activeFilters: 0,
      localStorageKey: TABLE_IFRAME_MEDIA_LIBRARY,
      customQueries: null,
      selectedFlow: null,
      showCreateMedia: false,
    }
  },
  methods: {
    onMediaClicked: function(row) {
      this.$router.push( `/${this.iframeService.slug}/${this.iframeService.slug}/media-library/${row.id}` )
    },
    onFiltersUpdated: function (activeFilters) {
      this.activeFilters = activeFilters
    },
    toggleFilters: function () {
      this.showFilters = !this.showFilters
    },
    onClickCreateMedia: function () {
      console.log('click create');

      this.showCreateMedia = true
    },
    onMediaCreateCancel: function() {
      console.log('cancel');
      this.showCreateMedia = false
    },
    onCreated: function() {
      console.log('created');

      this.showCreateMedia = false
      this.refreshTable()
    },
    refreshTable: function() {
      this.$refs.iframeMediaTable.reload()
    }
  },
  computed: {
    iframeService: function () {
      return this.$store.state.services.find(service => service.slug === 'iframe') || null
    },
    entities: function () {
      return this.iframeService ? this.iframeService.entities : null
    },
  }
}
</script>

<style scoped>

</style>
